/**
 * Utility functions for handling paste operations
 */

/**
 * Handle paste event in table cells
 * @param {number} rowIndex - Row index where paste occurred
 * @param {number} colIndex - Column index where paste occurred
 * @param {Event} event - Paste event
 * @param {Array} rows - Current rows
 * @param {boolean} splitMode - Whether split mode is enabled
 * @param {Array} fixedNetworkAdjustmentFactors - Fixed factors array
 * @returns {Array} - Updated rows array
 */
export function handlePasteData(rowIndex, colIndex, event, rows, splitMode, fixedNetworkAdjustmentFactors) {
  event.preventDefault();
  const clipboardData = event.clipboardData || window.clipboardData;
  const pastedData = clipboardData.getData('text');
  const filteredData = pastedData.replace(/[^\d.,\t\n]/g, '');
  const newRows = filteredData.split('\n').map(row => row.split('\t'));

  if (rowIndex === -1 || colIndex <= 0) {
    return rows;
  }

  let updatedRows = [...rows];
  newRows.forEach((newRow, i) => {
    const existingRowIndex = rowIndex + i;
    if (existingRowIndex < updatedRows.length) {
      const updatedRow = [...updatedRows[existingRowIndex]];
      newRow.forEach((cell, j) => {
        const targetColIndex = colIndex + j;
        if (targetColIndex < updatedRow.length) {
          if (splitMode && Array.isArray(updatedRow[targetColIndex])) {
            updatedRow[targetColIndex][0] = cell;
            
            if (cell !== '' && targetColIndex !== 0 && fixedNetworkAdjustmentFactors[existingRowIndex] !== true && (updatedRow[targetColIndex][1] === '' || updatedRow[targetColIndex][1] === undefined)) {
              updatedRow[targetColIndex][1] = '100';
            }
          } else {
            updatedRow[targetColIndex] = cell;
          }
        }
      });
      updatedRows[existingRowIndex] = updatedRow;
    }
  });

  return updatedRows;
}

/**
 * Handle cell value change with validation
 * @param {number} originalIndex - Original row index
 * @param {number} colIndex - Column index
 * @param {string} value - New value
 * @param {number} part - Part index for split mode
 * @param {Array} rows - Current rows
 * @param {boolean} splitMode - Whether split mode is enabled
 * @param {Array} fixedNetworkAdjustmentFactors - Fixed factors array
 * @param {string} title - Row title
 * @returns {Object} - Object with validation result and updated rows
 */
export function handleCellValueChange(originalIndex, colIndex, value, part, rows, splitMode, fixedNetworkAdjustmentFactors, title) {
  const updatedRows = [...rows];
  
  if (splitMode) {
    let currentValue = updatedRows[originalIndex][colIndex] || ['', ''];
    if (Array.isArray(currentValue[0])) currentValue = currentValue[0];

    const regex = title === "Dias de internação"
      ? /^[0-9.,]*$/
      : /^\d*$/;

    if (regex.test(value) || value === '') {
      currentValue[part] = value;

      if (
        part === 0 &&
        value !== '' &&
        colIndex !== 0 &&
        fixedNetworkAdjustmentFactors[originalIndex] !== true
      ) {
        if (currentValue[1] === '' || currentValue[1] === undefined) {
          currentValue[1] = '100';
        }
      }
      
      updatedRows[originalIndex][colIndex] = currentValue;
      return { isValid: true, updatedRows };
    }
    return { isValid: false, updatedRows: rows };
  } else {
    updatedRows[originalIndex][colIndex] = value;
    return { isValid: true, updatedRows };
  }
}
